@import '@hevoio/hevo-ui-toolkit/styles/variables';

.nodeLogo {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-shrink: 0;

  &.disabled {
    opacity: .6;
  }

  &.nodeLogoRoundedBorders {
    border-radius: 50% !important;
    overflow: hidden;
  }
}

@mixin node-image-sizer($thumb-size, $spacing) {
  $container-size: $thumb-size + 2 * $spacing;
  width: $container-size;
  height: $container-size;
  img {
    max-width: $thumb-size;
    max-height: $thumb-size;
  }
}

$node-image-sizes: (
        1: (16px, 4px),
        2: (16px, 6px),
        3: (20px, 4px),
        4: (24px, 6px),
        5: (24px, 8px),
        6: (36px, 8px),
        7: (36px, 12px),
        8: (16px, 2px),
        9: (36px, 4px),
        10: (32px, 8px),
        lg: (36, 12),
        md: (24, 8),
        md1: (24, 6),
        md2: (20, 6),
        sm: (16, 6),
        xs: (16, 4),
        cs: (36, 8)
);

.nodeLogo {
  @each $index, $node-image-config in $node-image-sizes {
    $thumb-size: nth($node-image-config, 1);
    $spacing-size: nth($node-image-config, 2);

    &.nodeLogoSize#{$index} {
      @include node-image-sizer($thumb-size, $spacing-size);
      border-radius: $border-radius-xl;

      @if $index == 6 or index == cs {
        border-radius: $border-radius-md;
      }

      @if $index == 10 {
        border-radius: $border-radius-md;
      }
    }
  }
}

.hideBackground {
  width: unset !important;
  height: unset !important;
}
